module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAAAXNSR0IArs4c6QAAAQNJREFUGBltjzFOA0EMRf29s0lECTSRSGaAbdJAC10uwRU4Qg7BEcgRoKeFihIEUqpdIFoEFIgywO6yxp4g0cSSx57/7K8ZkEaWZVt105yQ0NjuBLpMnZvkef4Mg1Xd3Kq8EeH/8dFJ3T7HTYUAXaQuGao4sF7n1o3B+/AiRH2DRVGUZvDnWoLolRW2JtZJklq1qJg7VpUJq92VXfBdTUMY93S7a33U9LHwo1FfFl93OrxJjGMD1MqprrxjrbfHT7PZm7osTGdJ7i2t169+RhZCdtBKc01AOX988Mb89s6cRAYMd8iCn6PlgpwDkGXSmWnGMPQh137XhBVRMAg3K0CUjP0CoLJf8RJYF7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/check-in-expanded-01-copy-10-shape-10@2x.png
// module id = 95
// module chunks = 0